import { createFileRoute } from '@tanstack/react-router';
import { UnitsProvider, UnitsView } from '@ludolio/shared-units';
import { useLibrarianUnitsModule } from '@/units/librarianUnitsModule';

export const Route = createFileRoute('/_authenticated/units/')({
  component: UnitsPage,
});

function UnitsPage() {
  const module = useLibrarianUnitsModule();
  return (
    <UnitsProvider module={module}>
      <UnitsView />
    </UnitsProvider>
  );
}
